<table style="overflow: hidden">
  <tbody>
    <div class="duration-result">
      {{ value }}
    </div>
    <tr *ngIf="config.unitSteps && config.showButtons">
      <td *ngIf="config.showNegative"></td>

      <td *ngIf="config.unitSteps.days && config.showDays">
        <a class="btn btn-link" id="dp-days-up" (click)="days = days + config.unitSteps.days" [ngClass]="{ disabled: disabled }">
          <span class="bs-chevron bs-chevron-up"></span>
        </a>
      </td>

      <td *ngIf="config.unitSteps.hours && config.showHours">
        <a class="btn btn-link" id="dp-hours-up" (click)="hours = hours + config.unitSteps.hours" [ngClass]="{ disabled: disabled }">
          <span class="bs-chevron bs-chevron-up"></span>
        </a>
      </td>

      <td *ngIf="config.unitSteps.minutes && config.showMinutes">
        <a
          class="btn btn-link"
          id="dp-minutes-up"
          (click)="minutes = minutes + config.unitSteps.minutes"
          [ngClass]="{ disabled: disabled }">
          <span class="bs-chevron bs-chevron-up"></span>
        </a>
      </td>

      <td *ngIf="config.unitSteps.seconds && config.showSeconds">
        <a
          class="btn btn-link"
          id="dp-seconds-up"
          (click)="seconds = seconds + config.unitSteps.seconds"
          [ngClass]="{ disabled: disabled }">
          <span class="bs-chevron bs-chevron-up"></span>
        </a>
      </td>
    </tr>

    <tr>
      <td *ngIf="config.showNegative">
        <a class="btn btn-link status-container" id="dp-sign" (click)="negative = !negative" [ngClass]="{ disabled: disabled }">
          <span *ngIf="!negative" class="bs-icon bs-icon-plus"></span>
          <span *ngIf="negative" class="bs-icon bs-icon-minus"></span>
        </a>
      </td>

      <td *ngIf="config.showDays">
        <mat-form-field class="form-field">
          <input matInput (blur)="onTouched()" type="number" placeholder="Jours" id="dp-days" [(ngModel)]="days" [disabled]="disabled" />
        </mat-form-field>
      </td>

      <td *ngIf="config.showHours">
        <mat-form-field class="form-field">
          <input matInput (blur)="onTouched()" type="number" placeholder="Heures" id="dp-hours" [(ngModel)]="hours" [disabled]="disabled" />
        </mat-form-field>
      </td>

      <td *ngIf="config.showMinutes">
        <mat-form-field class="form-field">
          <input
            matInput
            (blur)="onTouched()"
            type="number"
            placeholder="Minutes"
            id="dp-minutes"
            [(ngModel)]="minutes"
            [disabled]="disabled" />
        </mat-form-field>
      </td>

      <td *ngIf="config.showSeconds">
        <mat-form-field class="form-field">
          <input
            matInput
            (blur)="onTouched()"
            type="number"
            placeholder="Secondes"
            id="dp-seconds"
            [(ngModel)]="seconds"
            [disabled]="disabled" />
        </mat-form-field>
      </td>

      <td *ngIf="config.showPreview">
        <span id="dp-duration-value">{{ preview }}</span>
      </td>
    </tr>

    <tr *ngIf="config.showButtons && config.unitSteps">
      <td *ngIf="config.showNegative"></td>

      <td *ngIf="config.unitSteps.days && config.showDays">
        <a class="btn btn-link" id="dp-days-down" (click)="days = days - config.unitSteps.days" [ngClass]="{ disabled: disabled }">
          <span class="bs-chevron bs-chevron-down"></span>
        </a>
      </td>

      <td *ngIf="config.unitSteps.hours && config.showHours">
        <a class="btn btn-link" id="dp-hours-down" (click)="hours = hours - config.unitSteps.hours" [ngClass]="{ disabled: disabled }">
          <span class="bs-chevron bs-chevron-down"></span>
        </a>
      </td>

      <td *ngIf="config.unitSteps.minutes && config.showMinutes">
        <a
          class="btn btn-link"
          id="dp-minutes-down"
          (click)="minutes = minutes - config.unitSteps.minutes"
          [ngClass]="{ disabled: disabled }">
          <span class="bs-chevron bs-chevron-down"></span>
        </a>
      </td>

      <td *ngIf="config.unitSteps.seconds && config.showSeconds">
        <a
          class="btn btn-link"
          id="dp-seconds-down"
          (click)="seconds = seconds - config.unitSteps.seconds"
          [ngClass]="{ disabled: disabled }">
          <span class="bs-chevron bs-chevron-down"></span>
        </a>
      </td>
    </tr>

    <div style="float: right">
      <button mat-raised-button aria-label="Annuler" [ngClass]="'primary'" (click)="cancel()">
        <div class="mat-buttom-with-icon">
          <mat-icon>cancel</mat-icon>
          Annuler
        </div>
      </button>
      <button mat-raised-button aria-label="Valider" [ngClass]="'primary'" (click)="valider()" style="margin: 0 15px">
        <div class="mat-buttom-with-icon">
          <mat-icon>check_circle</mat-icon>
          Valider
        </div>
      </button>
    </div>
  </tbody>
</table>
